import { useRef, useState } from 'react';
import {
  IShopNavigationMenu,
  IShopNavigationMenuItem,
} from '@components/shared/shop/ShopNavigationMenu/model';

export default function useShopMenu() {
  const [isNavOpen, setIsNavOpen] = useState(false);
  const [activeDropdownMenu, setActiveDropdownMenu] = useState<IShopNavigationMenu | null>(null);
  const [animateDropdownContent, setAnimateDropdownContent] = useState(false);
  const navRef = useRef<HTMLDivElement>(null);

  const closeNav = () => {
    setActiveDropdownMenu(null);
    setIsNavOpen(false);
    setAnimateDropdownContent(false);
  };

  const openNav = (menu: IShopNavigationMenu) => {
    setActiveDropdownMenu(menu);
    setAnimateDropdownContent(true);
    setIsNavOpen(true);
  };

  const isActiveOption = (item: IShopNavigationMenuItem) => {
    return activeDropdownMenu && activeDropdownMenu.item?.title === item.title;
  };

  return {
    activeDropdownMenu,
    animateDropdownContent,
    closeNav,
    isActiveOption,
    isNavOpen,
    navRef,
    openNav,
    setActiveDropdownMenu,
    setAnimateDropdownContent,
    setIsNavOpen,
  };
}
